export const isLoading = (state) => state.isLoading;
export const currentRoute = (state) => state.route;
